
var id = "detail";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 240 240\" id=\"detail\">\n<style type=\"text/css\">\n\t#detail .st0{}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M160,80H80c-5.52,0-10,4.48-10,10s4.48,10,10,10h80c5.52,0,10-4.48,10-10S165.52,80,160,80z\" />\n\t<path class=\"st0\" d=\"M160,110H80c-5.52,0-10,4.48-10,10s4.48,10,10,10h80c5.52,0,10-4.48,10-10S165.52,110,160,110z\" />\n\t<path class=\"st0\" d=\"M120,140H80c-5.52,0-10,4.48-10,10s4.48,10,10,10h40c5.52,0,10-4.48,10-10S125.52,140,120,140z\" />\n\t<path class=\"st0\" d=\"M197.43,183.28C211.53,166.05,220,144.01,220,120c0-55.23-44.77-100-100-100S20,64.77,20,120\n\t\ts44.77,100,100,100c24.01,0,46.05-8.47,63.28-22.57l19.64,19.64c3.91,3.91,10.24,3.91,14.14,0c3.91-3.91,3.91-10.24,0-14.14\n\t\tL197.43,183.28z M120,200c-44.18,0-80-35.82-80-80s35.82-80,80-80s80,35.82,80,80S164.18,200,120,200z\" />\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
